import React from 'react';
import Select from 'react-select';
import styles from './styles.module.scss';
import enhance from './enhance';

export const QuantityDropdown = ({
  onQuantityChange,
  quantityOptions,
  disabled,
  openMultiplePriorities,
  multiplePriorities,
  multiplePrioritiesSelected,
  isDuplicate,
  displayQuantity,
}) => {
  return multiplePriorities ? (
    <span className={styles.staticQuantity}>{displayQuantity}</span>
  ) : (
    <Select
      disabled={disabled}
      className={styles.quantitySelect}
      value={isDuplicate ? 0 : displayQuantity}
      clearable={false}
      style={{ borderRadius: 0 }}
      onChange={onQuantityChange}
      onOpen={multiplePrioritiesSelected ? openMultiplePriorities : null}
      options={quantityOptions}
      menuStyle={{ backgroundColor: '#E9E9EE' }}
    />
  );
};

export default enhance(QuantityDropdown);
